<template functional>
	<span>
		<svg
			v-if="props.filled"
			xmlns="http://www.w3.org/2000/svg"
			:width="props.size"
			:height="props.size"
			viewBox="0 0 130 130"
		><path :style="`fill: ${props.color}`" d="M64.9998,73.15533c-13.53565,0-24.54737-12.64991-24.54737-28.19825S51.46415,16.75884,64.9998,16.75884,89.54765,29.40875,89.54765,44.95708,78.53544,73.15533,64.9998,73.15533ZM102.73612,113.168H27.26737a9.75645,9.75645,0,0,1-9.80566-9.68359l-.00342-10.46387a6.87585,6.87585,0,0,1,1.542-3.82764l.08692-.09863c3.98584-4.36523,14.19238-11.94922,24.373-17.084l2.54-1.28125,2.044,1.979a23.80885,23.80885,0,0,0,33.91162,0l2.04395-1.979,2.54052,1.28125c10.18018,5.13525,20.38623,12.71924,24.37207,17.084l.08741.09912a6.87415,6.87415,0,0,1,1.542,3.82569v10.46533A9.75645,9.75645,0,0,1,102.73612,113.168Z" /></svg>
		<svg xmlns="http://www.w3.org/2000/svg" :width="props.size" :height="props.size" viewBox="0 0 130 130"><path :style="`fill: ${props.color}`" d="M64.9998,73.15533c-13.53565,0-24.54737-12.64991-24.54737-28.19825S51.46415,16.75884,64.9998,16.75884,89.54765,29.40875,89.54765,44.95708,78.53544,73.15533,64.9998,73.15533Zm0-48.39649c-9.124,0-16.54737,9.061-16.54737,20.19824S55.87577,65.15533,64.9998,65.15533c9.12451,0,16.54785-9.061,16.54785-20.19825S74.12431,24.75884,64.9998,24.75884ZM102.73612,113.168H27.26737a9.75645,9.75645,0,0,1-9.80566-9.68359l-.00342-10.46387a6.87585,6.87585,0,0,1,1.542-3.82764l.08692-.09863c3.98584-4.36523,14.19238-11.94922,24.373-17.084l2.54-1.28125,2.044,1.979a23.80885,23.80885,0,0,0,33.91162,0l2.04395-1.979,2.54052,1.28125c10.18018,5.13525,20.38623,12.71924,24.37207,17.084l.08741.09912a6.87415,6.87415,0,0,1,1.542,3.82569v10.46533A9.75645,9.75645,0,0,1,102.73612,113.168ZM25.45878,93.99908l.00293,9.48388a1.77135,1.77135,0,0,0,1.80566,1.68506h75.46875a1.77115,1.77115,0,0,0,1.80567-1.68359V93.99957c-3.4126-3.4917-11.17725-9.22608-19.2124-13.59278a31.63759,31.63759,0,0,1-40.6587,0C36.63554,84.773,28.87138,90.50689,25.45878,93.99908Z" /></svg>
	</span>
</template>

<script>
export default {
	name: 'UserIcon',
	props: {
		color: {
			type: String,
			default: '#2487C4'
		},
		filled: Boolean,
		size: {
			type: Number,
			default: 25
		}
	}
};
</script>